module.exports = __webpack_public_path__ + "static/media/send.8db42ca2.svg";